import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'taskSchedule';

const taskScheduleService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  generateTasks: (id) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/generateTasks/${id}`,
    });
  },
};
export default taskScheduleService;
